<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark align-center color="primary">
            <v-toolbar-title>
              {{ appName }}
            </v-toolbar-title>

            <v-spacer/>

            <v-avatar
              color="primary"
              size="128"
            >
              <v-img :src="logo" alt="iK_logo" height="103" contain />
            </v-avatar>
          </v-toolbar>

          <v-card-text>
            <v-form lazy-validation @submit.prevent="login" id="check-login-form" >
              <v-text-field
                id="username"
                prepend-icon="person"
                v-model="username"
                name="username"
                label="Nombre de usuario"
                type="text"
                :counter="20"
                maxlength="20"
                :rules="nameRules"
                required
              ></v-text-field>

              <v-text-field
                id="password"
                prepend-icon="lock"
                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                v-model="password"
                name="password"
                label="Contraseña"
                :type="showPassword ? 'text' : 'password'"
                :counter="30"
                maxlength="30"
                :rules="passwordRules"
                @click:append="showPassword = !showPassword"
                required
              ></v-text-field>
            </v-form>
          </v-card-text>

          <v-alert :value="alert" type="error">
            {{ message }}
          </v-alert>

          <v-card-actions>
            <v-btn block round dark color="primary"
              type="submit" form="check-login-form"
              @click="alert = false"
            >
              Ingresar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  name: `Login`,

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'login-layout')
    let appConf = this.$store.state.appConf
    this.appName = appConf.appName
    this.logo = appConf.logo
  },

  data: () => ({
    appName: null,
    logo: null,
    username: '',
    password: '',
    showPassword: false,
    nameRules: [
      v => !!v || 'Se requiere un nombre de usuario'
    ],
    passwordRules: [
      v => !!v || 'Se requiere una contraseña'
    ],
    message: '',
    alert: false
  }),

  methods: {
    login: function () {
      let username = this.username
      let password = this.password
      this.$store.dispatch('login', { username, password })
        .then(() => this.$router.push('/projects'))
        .catch(err => {
          console.log(err)
          this.message = err.data.non_field_errors[0]
          this.alert = true
        })
    }
  }
}
</script>
